export default __webpack_public_path__ + "static/media/msft-token.335cfefd.png";